/* Small, Norway and Sweden adapter for the existing Appstle widget. No tracking added. */
(() => {
  'use strict';
  if (!['www.nordiclongevitylabs.no', 'nordiclongevitylabs.no', 'www.nordiclongevitylabs.se', 'nordiclongevitylabs.se'].includes(location.hostname) && document.documentElement.dataset.nllMarket !== 'se' && !window.Shopify?.designMode) return;
  if (document.documentElement.dataset.nllMarket === 'se') {
    const translateReviews = () => {
      document.querySelectorAll('.jdgm-carousel-title').forEach(element => {
        if (element.textContent.trim() === 'Let customers speak for us') element.textContent = 'Låt kunderna tala för oss';
      });
      document.querySelectorAll('.jdgm-carousel-number-of-reviews').forEach(element => {
        const count = element.textContent.trim().match(/^from\s+([\d, ]+)\s+reviews?$/i);
        if (count) element.textContent = `från ${count[1]} recensioner`;
      });
    };
    translateReviews();
    const reviewObserver = new MutationObserver(translateReviews);
    reviewObserver.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => reviewObserver.disconnect(), 20000);
  }
  const root = document.querySelector('[data-nll-purchase]');
  if (!root) return;
  const swedishWidgets = new WeakSet();
  const translateWidget = widget => {
    const walker = document.createTreeWalker(widget, NodeFilter.SHOW_TEXT);
    const replacements = [
      [/Engangskjøp/g, 'Engångsköp'],
      [/Abonnér og spar/g, 'Prenumerera och spara'],
      [/\bSPAR\b/g, 'SPARA'],
      [/Månedsabonnement/g, 'Månadsprenumeration'],
      [/Abonnementet kan kanselleres etter/g, 'Prenumerationen kan avslutas efter'],
      [/første og påfølgende levering/g, 'den första och efterföljande leveransen'],
      [/Vi verdsetter din lojalitet og støtte/g, 'Vi uppskattar din lojalitet och ditt stöd'],
      [/økes rabatten til/g, 'ökar rabatten till'],
      [/\better\b/g, 'efter'],
      [/måneder/g, 'månader'],
      [/\bMotta\b/g, 'Få'],
      [/\bposer\b/g, 'påsar'],
      [/\bpose\b/g, 'påse'],
      [/hver måned/g, 'varje månad'],
      [/kapsler/g, 'kapslar'],
      [/\bhver\b/g, 'var'],
      [/\bmåned\b/g, 'månad'],
      [/Kjøpsvalg/g, 'Köpalternativ']
    ];
    let node;
    while ((node = walker.nextNode())) {
      if (node.parentElement?.closest('script, style, textarea')) continue;
      let translated = node.nodeValue;
      for (const [pattern, replacement] of replacements) translated = translated.replace(pattern, replacement);
      if (translated !== node.nodeValue) node.nodeValue = translated;
    }
  };
  const syncSwedishWidgets = () => {
    if (document.documentElement.dataset.nllMarket !== 'se') return;
    root.querySelectorAll('.appstle_subscription_wrapper').forEach(widget => {
      translateWidget(widget);
      if (swedishWidgets.has(widget)) return;
      swedishWidgets.add(widget);
      const widgetObserver = new MutationObserver(() => translateWidget(widget));
      widgetObserver.observe(widget, { childList: true, characterData: true, subtree: true });
    });
  };
  const reviewSelector = '[id$="judge_me_reviews_featured_carousel_MMXEFB"]';
  const openReviews = event => {
    const badge = event.target.closest('.nll-no-product .jdgm-preview-badge');
    const carousel = document.querySelector(reviewSelector);
    if (!badge || !carousel) return;
    if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    carousel.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };
  document.addEventListener('click', openReviews, true);
  document.addEventListener('keydown', openReviews, true);
  const purchaseQuery = new URLSearchParams(location.search);
  const explicitPlan = purchaseQuery.has('selling_plan');
  const explicitOneTime = purchaseQuery.get('purchase') === 'one-time';
  let touched = false;
  let finished = explicitPlan;
  let queued = false;
  const touch = e => { if (e.isTrusted) touched = true; };
  root.addEventListener('pointerdown', touch, { capture: true });
  root.addEventListener('keydown', touch, { capture: true });
  function syncNotes() {
    const checked = root.querySelector('input[name="selling_plan"]:checked');
    const hidden = root.querySelector('input[type="hidden"][name="selling_plan"]');
    const subscription = Boolean((checked || hidden)?.value);
    root.querySelectorAll('[data-nll-onetime-note], [data-nll-onetime-payment]').forEach(el => { el.hidden = subscription; });
    root.querySelectorAll('[data-nll-subscription-note], [data-nll-subscription-payment]').forEach(el => { el.hidden = !subscription; });
  }
  function reconcile() {
    queued = false;
    syncSwedishWidgets();
    const initialChoice = explicitOneTime
      ? root.querySelector('.appstle_subscription_wrapper input[type="radio"][name="selling_plan"][value=""]')
      : root.querySelector('.appstle_include_dropdown input[type="radio"][name="selling_plan"]:not([value=""])');
    if (initialChoice && !finished) {
      finished = true;
      // Use the app's own event handlers. Never overwrite a shopper's choice
      // or a selling plan explicitly provided in an incoming link.
      if (!touched && !initialChoice.checked) initialChoice.click();
    }
    syncNotes();
  }
  const observer = new MutationObserver(() => {
    if (!queued) { queued = true; requestAnimationFrame(reconcile); }
  });
  observer.observe(root, { childList: true, subtree: true });
  root.addEventListener('change', () => requestAnimationFrame(syncNotes));
  reconcile();
  // The observer is only needed during the app's initial render.
  window.setTimeout(() => observer.disconnect(), 20000);
})();

